import { render } from "./FancyImagebox.vue?vue&type=template&id=df36a0b8"
import script from "./FancyImagebox.vue?vue&type=script&lang=js"
export * from "./FancyImagebox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__